import { ga } from 'js/analytics/adapters'
export const trackStartVideo = () => {
  ga.track('Started video')
}
